export default {
    computed: {
        // Get client surcharge
        clientSurcharge() {
            try {
                if (this.fields.client && this.fields.client.data && this.fields.client.data.surcharge > 0) {
                    return 0.5
                }

                return 0
            } catch (err) {
                console.error(err)
                return 0
            }
        },
        // Check if client is selected
        isClientSelected() {
            if (this.fields.client && this.fields.client.data) return true
            return false
        },
        // Check if current user can view prices
        showPrices() {
            const group = this.$gestios.auth.check({ scopes: ['_BOSS'] })

            if (this.fields.client) {
                if (
                    (this.fields.client.data !== undefined && this.fields.client.data.show_prices === 1) ||
                    group !== 8
                ) {
                    return true
                }
            }

            return false
        },
    },
    methods: {
        // Reset client data
        resetClient() {
            this.fields.client = null
            this.fields.client_address = ''
            this.fields.client_cp = ''
            this.fields.client_location = ''
            this.fields.client_state = ''
            this.fields.client_country = ''
            this.fields.client_name = ''
            this.fields.client_cif = ''
            this.fields.client_legal_name = ''
        },
        // Assign client data
        changeClient(client) {
            if (!this.loading) {
                if (client !== undefined && client.data !== undefined) {
                    this.fields.client_address = client.data.address
                    this.fields.client_cp = client.data.cp
                    this.fields.client_location = client.data.location
                    this.fields.client_state = client.data.state
                    this.fields.client_country = client.data.country
                    this.fields.client_name = client.data.name
                    this.fields.client_cif = client.data.cif
                    this.fields.client_legal_name = client.data.legal_name
                } else {
                    this.resetClient()
                }
            }
        },
    },
}
